import { IOption } from "@/types"
import { ReactNode } from "react"
import ReactSelect, { components, StylesConfig } from "react-select"
import { AutocompleteConfig } from "./config"
import { DropdownIcon } from "./DropdownIcon"
import "./style.sass"

interface AutocompleteProps<T extends string | number, M extends object = object> {
  size?: "sm" | "md"
  options: IOption<T, M>[]
  value?: IOption<T, M>
  error?: string
  onChange?: (value: IOption<T, M> | null) => void
  renderOption?: (value: IOption<T, M> | null) => ReactNode
  getOptionLabel?: (value: IOption<T, M> | null) => string
  label?: string
  styles?: StylesConfig<IOption<T, M>>
  searchable?: boolean
  emptyMessage?: string
  mode?: "text" | "default"
  className?: string
  disabled?: boolean
  loading?: boolean
}
export const Autocomplete = <T extends string | number, M extends object = object>({
  size = "md",
  options,
  loading,
  value,
  onChange,
  renderOption,
  label,
  styles,
  searchable = false,
  emptyMessage,
  error,
  className,
  getOptionLabel,
  disabled,
}: AutocompleteProps<T, M>) => {
  return (
    <div className={className}>
      <ReactSelect
        isLoading={loading}
        isDisabled={disabled}
        value={value ?? null}
        placeholder={label}
        onChange={(value) => onChange?.(value)}
        formatOptionLabel={renderOption != null ? (data) => renderOption(data) : undefined}
        components={{
          DropdownIndicator: ({ children, ...props }) => (
            <components.DropdownIndicator {...props}>
              <DropdownIcon up={false} />
              {children}
            </components.DropdownIndicator>
          ),
        }}
        getOptionLabel={getOptionLabel}
        styles={styles}
        options={options}
        classNames={AutocompleteConfig<T, M>(size, error != null)}
        menuPortalTarget={document.getElementById("root")}
        classNamePrefix="custom-autocomplete"
        isSearchable={searchable}
        noOptionsMessage={() => emptyMessage}
      />
      {error != null && <span className="text-red-500">{error}</span>}
    </div>
  )
}
